export default function getPageViewEventProperties() {
  return {
    event: 'page view',
    pageUrl: window.location.href,
    pageTitle: document.title,
    referrer: window.previousPath || '',
    originalLocation: localStorage.getItem('userEnteredBy'),
  };
}
